import React, { useEffect, useState, useRef } from 'react'
import * as S from './styles'
import PlanSelector from '@site/components/molecules/PlanSelector/PlanSelector'
import DeliveryFeeModal from '@site/components/DeliveryModal'
import ClubCarouselCard from '@site/components/molecules/ClubCarousel/ClubCarousel'
import CompareClubsCarousel from '@site/components/molecules/CompareClubsCarousel/CompareClubsCarousel'
import { isMobile } from 'react-device-detect'
import { StrapiCompareClubs, StrapiPlan } from '@shared/utils/strapi/strapi.types'
import InfoTagsCloud from '../InfoTagsCloud'
import ModalWantBoth from '@site/components/molecules/ModalWantBoth/ModalWantBoth'
import { useHome } from '@site/contexts/homeContext'

type CompareClubsSectionProps = {
  compareClubs: StrapiCompareClubs
}

const CompareClubsSection = ( { compareClubs }: CompareClubsSectionProps ) => {
  const [ selectedPlan, setSelectedPlan ] = useState<StrapiPlan | undefined>( compareClubs.plans[ 1 ] )
  const [ showDeliveryFeeModal, setShowDeliveryFeeModal ] = useState( false )
  const [ showWantBothModal, setShowWantBothModal ] = useState( false )
  const ref = useRef<HTMLDivElement>( null )
  const { setScrollHeight } = useHome()

  const handleDeliveryFeeModal = () => {
    setShowDeliveryFeeModal( !showDeliveryFeeModal )
  }

  const handleWantBothModal = () => {
    setShowWantBothModal( !showWantBothModal )
  }

  const mapClubCards = ( selectedPlan: StrapiPlan ) => {
    return selectedPlan.cards.map( ( card, index ) => (
      <ClubCarouselCard
        card={ card }
        hasGift={ selectedPlan.cards.some( card => card.gift && card.gift !== '' ) }
        hasOriginalPrice={ selectedPlan.cards.some( card => card.originalPrice && card.originalPrice !== '' ) }
        key={ `plan_card_${index}` }
      />
    ) )
  }

  useEffect( () => {
    if ( ref.current ) {
      let height = ref.current.offsetHeight
      if ( isMobile ) {
        height += 150
      }
      setScrollHeight( height )
    }
  }, [] )

  return (
    <S.Section
      ref={ ref }
      className="compare-clubs-section"
    >
      <S.SectionWrapper>
        <S.Title>
          {compareClubs.title}
        </S.Title>
        <S.Subtitle>
          {compareClubs.subtitle}
        </S.Subtitle>
        <S.PlanSelectorWrapper>
          <PlanSelector
            compareClubs={ compareClubs }
            selectedPlan={ selectedPlan! }
            setSelectedPlan={ setSelectedPlan }
          />
        </S.PlanSelectorWrapper>

        <S.DeliveryFee onClick={ handleDeliveryFeeModal }>+ taxa de entrega</S.DeliveryFee>
        {
          !showDeliveryFeeModal ? null :
            <DeliveryFeeModal
              handleDeliveryFeeModal={ handleDeliveryFeeModal }
              showDeliveryFeeModal={ showDeliveryFeeModal }
            />
        }
        {
          !showWantBothModal ? null :
            <ModalWantBoth
              handleModal={ handleWantBothModal }
              showModal={ showWantBothModal }
            />
        }
      </S.SectionWrapper>

      { isMobile ? (
        <S.CarouselWrapper>
          <CompareClubsCarousel>
            { mapClubCards( selectedPlan! ) }
          </CompareClubsCarousel>
        </S.CarouselWrapper>
      ) : (
        <S.BoardWrapper>
          { mapClubCards( selectedPlan! ) }
        </S.BoardWrapper>
      ) }

      { compareClubs.infoTags ? <InfoTagsCloud infoTags={ compareClubs.infoTags } /> : null }

      <S.WrapperWantBoth>
        <S.ButtonWantBoth
          onClick={ handleWantBothModal }
        >
          Quer os dois? Saiba como.
        </S.ButtonWantBoth>
      </S.WrapperWantBoth>
    </S.Section>
  )
}

export default CompareClubsSection
